import React, { useState, useEffect } from "react";

interface LoadingChatDotsProps {}

const LoadingChatDots: React.FC<LoadingChatDotsProps> = ({ }) => {
    const [dotCount, setDotCount] = useState(1);

    useEffect(() => {
        const interval = setInterval(() => {
            setDotCount((prevCount) => (prevCount % 3) + 1);
        }, 500);

        return () => clearInterval(interval);
    }, []);

    return (
        <div className="fixed inset-0 flex justify-center items-center z-50">
            <div className="bg-white dark:bg-neutral-800 opacity-90 p-4 rounded-lg shadow-lg text-center">
                <h2 className="text-neutral-800 dark:text-neutral-300">Loading{".".repeat(dotCount)}</h2>
            </div>
        </div>
    );
};

export default LoadingChatDots;